<div *ngIf="!isUserDeviceOnline" class="offline-banner">
    <div class="d-flex flex-column gap-3 align-items-center">
        <lucide-icon
                name="WifiOff"
                size="170"
                [color]="colorOfWifiIcon"
                class="icon"></lucide-icon>
        <div class="d-flex flex-column align-items-center">
            <h2>You're Offline</h2>
            <p>
                No internet connection found.<br/>
                Please check your connection and try again.
            </p>
        </div>
    </div>
</div>
